import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#070A0E] text-white grid place-items-center px-4">
      <div data-testid="payment-cancel-state" className="card-surface rounded-2xl p-10 max-w-md w-full text-center">
        <div className="h-16 w-16 rounded-full bg-white/5 border border-white/10 grid place-items-center mx-auto mb-5">
          <XCircle className="h-9 w-9 text-slate-400" />
        </div>
        <h1 className="font-heading text-2xl font-extrabold">Checkout cancelled</h1>
        <p className="text-slate-400 text-sm mt-2">No charge was made. Your plan is unchanged — you can upgrade anytime.</p>
        <div className="flex gap-3 mt-7">
          <Button data-testid="cancel-back-pricing" onClick={() => navigate("/#pricing")} className="flex-1 bg-brand hover:bg-brand-hover text-white font-semibold">Back to Pricing</Button>
          <Button onClick={() => navigate("/")} variant="outline" className="flex-1 bg-transparent border-white/15 hover:bg-white/5 text-white">Home</Button>
        </div>
      </div>
    </div>
  );
}
